import { render, staticRenderFns } from "./ProxyTrafficList.vue?vue&type=template&id=105de3f1&scoped=true"
import script from "./ProxyTrafficList.vue?vue&type=script&lang=js"
export * from "./ProxyTrafficList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105de3f1",
  null
  
)

export default component.exports